import { ListView } from './ListView';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withLocale } from 'locale';
import { PoiId, LeadingAgentFeature } from 'utils/entities';
import { State, RootAction } from 'store/state';
import { routeSelector } from 'store/state/selectors/router';
import { navigateTo } from 'store/state/router/actions';
import { setActivePoiIds } from 'store/state/searchContext/actions';
import { exposureProjectSelector } from 'store/state/domainData/selectors/exposureProject';
import { filtersStateSelector } from 'store/state/selectors/search';
import {
  searchListTotalSelector,
  searchListTotalNearbySelector,
  searchLastInGeometryIdSelector,
  searchDocEntriesSelector,
  isSearchListLoadingSelector,
} from 'store/state/domainData/selectors';
import { pageSelector, multiSearchAwarePoiSelector, searchListTotalPagesSelector } from '../selectors';
import { searchListItemsPerPageLimit } from 'store/state/domainData/selectors';
import {
  isMobileMenuHiddenSelector,
  isSearchResultAdditionalBannerClosedSelector,
  searchViewModeSelector,
} from 'store/state/app/selectors';
import { setIsSearchResultAdditionalBannerClosed, setIntermediateSearchViewMode } from 'store/state/app/actions';
import { activeFiltersSelector, homeTypesSelector, sellerSelector } from 'components/document-head';
import { commercialArticlesSelector } from 'components/blog-carousel/search';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { leadingAgentsByDocIdsSelector } from 'store/state/domainData/selectors/searchAgentAwardsByDocIds';

const mapStateToProps = (state: State) => ({
  poi: multiSearchAwarePoiSelector(state),
  total: searchListTotalSelector(state),
  totalNearby: searchListTotalNearbySelector(state),
  lastInGeometryId: searchLastInGeometryIdSelector(state),
  totalPages: searchListTotalPagesSelector(state),
  isLoading: isSearchListLoadingSelector(state),
  resolvedAddresses: searchDocEntriesSelector(state),
  page: pageSelector(state),
  route: routeSelector(state),
  limit: searchListItemsPerPageLimit(state),
  filtersState: filtersStateSelector(state),
  isSearchResultAdditionalBannerClosed: isSearchResultAdditionalBannerClosedSelector(state),
  isMobileMenuHidden: isMobileMenuHiddenSelector(state),
  activeFilters: activeFiltersSelector(state),
  homeTypes: homeTypesSelector(state),
  seller: sellerSelector(state),
  articles: commercialArticlesSelector(state),
  mode: searchViewModeSelector(state).committedValue,
  leadingAgents: leadingAgentsByDocIdsSelector(state, LeadingAgentFeature.SearchResultsCarrousel),
  exposureProject: exposureProjectSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  setActive: (ids: PoiId[]) => dispatch(setActivePoiIds(ids, { source: 'list' })),
  onAdditionalBannerClose: () => dispatch(setIsSearchResultAdditionalBannerClosed(true)),
  setMode: (mode: SearchViewMode) => dispatch(setIntermediateSearchViewMode(mode)),
  navigateTo: (name: string, params?: Record<string, any>, opts?: Record<string, any>) => dispatch(navigateTo(name, params, opts)),
});

export default withLocale(connect(mapStateToProps, mapDispatchToProps)(ListView));
